module.exports = __webpack_public_path__ + "assets/img/1971591928118_.pic_hd.4d85a867.jpg";